export default "__VITE_ASSET__CfBjM$$d__"